import React from 'react'
import WarehouseOrgChart from '../WarehouseOrgChart'
import ManagementOrgChart from '../ManagementOrgChart'

function Orgcharts() {
    return (
        <div>
            <ManagementOrgChart />
            <WarehouseOrgChart />
        </div>
    )
}

export default Orgcharts